/**
 * @generated SignedSource<<026818e0b57b9bf0a477527bbec77a24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SiblingNavigation_siblingNavigation$data = {
  readonly links: ReadonlyArray<{
    readonly url: string;
    readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
  }>;
  readonly " $fragmentType": "SiblingNavigation_siblingNavigation";
};
export type SiblingNavigation_siblingNavigation$key = {
  readonly " $data"?: SiblingNavigation_siblingNavigation$data;
  readonly " $fragmentSpreads": FragmentRefs<"SiblingNavigation_siblingNavigation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiblingNavigation_siblingNavigation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SimpleLink",
      "kind": "LinkedField",
      "name": "links",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SimpleLink_simpleLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SiblingNavigation",
  "abstractKey": null
};

(node as any).hash = "eaa328e388ae1961b3eb5de70c6017ba";

export default node;
